import { Equipment } from '../types';

export const towerEquipmentDatabase: Equipment[] = [
  // Ubiquiti Rocket Dishes
  {
    id: 'ubnt-rd-5g30',
    name: 'RocketDish 5G-30',
    type: 'radio-dish',
    manufacturer: 'ubiquiti',
    price: 89,
    specifications: {
      frequency: '5GHz',
      gain: '30dBi',
      beamwidth: '6.2°'
    }
  },
  {
    id: 'ubnt-rd-5g34',
    name: 'RocketDish 5G-34',
    type: 'radio-dish',
    manufacturer: 'ubiquiti',
    price: 129,
    specifications: {
      frequency: '5GHz',
      gain: '34dBi',
      beamwidth: '4.5°'
    }
  },

  // Ubiquiti airFiberX Dishes (S45)
  {
    id: 'ubnt-afx-5g-34-s45',
    name: 'airFiberX 5GHz 34dbi S45',
    type: 'radio-dish',
    manufacturer: 'ubiquiti',
    price: 0,
    specifications: {
      frequency: '5GHz',
      gain: '34dBi',
      beamwidth: '4.5°'
    }
  },
  {
    id: 'ubnt-afx-5g-30-s45',
    name: 'airFiberX 5GHz 30dbi S45',
    type: 'radio-dish',
    manufacturer: 'ubiquiti',
    price: 0,
    specifications: {
      frequency: '5GHz',
      gain: '30dBi',
      beamwidth: '6.2°'
    }
  },
  {
    id: 'ubnt-afx-5g-23-s45',
    name: 'airFiberX 5GHz 23dbi S45',
    type: 'radio-dish',
    manufacturer: 'ubiquiti',
    price: 0,
    specifications: {
      frequency: '5GHz',
      gain: '23dBi',
      beamwidth: '12°'
    }
  },

  // Ubiquiti Sector Antennas
  {
    id: 'ubnt-am-5g19-120',
    name: 'airMAX Sector 5GHz 19dBi 120°',
    type: 'sector-antenna',
    manufacturer: 'ubiquiti',
    price: 119,
    specifications: {
      frequency: '5GHz',
      gain: '19dBi',
      beamwidth: '120°'
    }
  },
  {
    id: 'ubnt-am-5g20-90',
    name: 'airMAX Sector 5GHz 20dBi 90°',
    type: 'sector-antenna',
    manufacturer: 'ubiquiti',
    price: 139,
    specifications: {
      frequency: '5GHz',
      gain: '20dBi',
      beamwidth: '90°'
    }
  },
  {
    id: 'ubnt-am-2g16-90',
    name: 'airMAX Sector 2.4GHz 16dBi 90°',
    type: 'sector-antenna',
    manufacturer: 'ubiquiti',
    price: 99,
    specifications: {
      frequency: '2.4GHz',
      gain: '16dBi',
      beamwidth: '90°'
    }
  }
];

